// src/modules/app-views/services/pages/Document/tabs/AiInfoTab/ClassificationSection.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Descriptions, Collapse, theme } from 'antd';
import { TagsOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import { DEFAULT_OPEN_KEYS } from './index';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ClassificationSection = ({ data, aiResponse, isMobile }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { token } = theme.useToken();
  const cl = aiResponse?.classification;
  const um = aiResponse?.unitOfMeasure;

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const hasData = (cl && (cl.category || cl.subcategory)) || (um && um.unit);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!hasData) return null;

  return (
    <Collapse
      className="collapsed-content-fit"
      defaultActiveKey={DEFAULT_OPEN_KEYS.includes('classification') ? ['classification'] : []}
      style={{ marginBottom: 16 }}
      items={[
        {
          key: 'classification',
          label: (
            <Flex align="center" gap={8}>
              <TagsOutlined style={{ color: token.colorPrimary }} />
              <span style={{ fontWeight: 600 }}>{translateX('classification')}</span>
            </Flex>
          ),
          showArrow: false,
          children: (
            <Descriptions
              bordered
              size="small"
              column={1}
              layout={isMobile ? 'vertical' : 'horizontal'}
              styles={{ label: { fontWeight: 500 } }}
            >
              {cl?.category && (
                <Descriptions.Item label={translateX('category')}>
                  {cl.category}
                </Descriptions.Item>
              )}
              {cl?.subcategory && (
                <Descriptions.Item label={translateX('subcategory')}>
                  {cl.subcategory}
                </Descriptions.Item>
              )}
              {um?.unit && (
                <Descriptions.Item label={translateX('unit')}>
                  {um.unit}
                  {um.description && ` - ${um.description}`}
                </Descriptions.Item>
              )}
            </Descriptions>
          ),
        },
      ]}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ClassificationSection;
